import { makeSvgIcon } from "./svg-icon";
import svg from "./terminal-material-icon.svg?react";

export const TerminalMaterialIcon = makeSvgIcon(
  svg,
  (theme) => theme.palette.grey[900],
);

export default TerminalMaterialIcon;
